var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddToHome = function SvgAddToHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#F5A623",
    rx: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121314",
    d: "M234 142h44v228h-44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121314",
    d: "M143 233h225v45H143z"
  })));
};
export { SvgAddToHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiByeD0iMTAwIiBmaWxsPSIjRjVBNjIzIi8+CjxyZWN0IHg9IjIzNCIgeT0iMTQyIiB3aWR0aD0iNDQiIGhlaWdodD0iMjI4IiBmaWxsPSIjMTIxMzE0Ii8+CjxyZWN0IHg9IjE0MyIgeT0iMjMzIiB3aWR0aD0iMjI1IiBoZWlnaHQ9IjQ1IiBmaWxsPSIjMTIxMzE0Ii8+Cjwvc3ZnPgo=";